module.exports = __webpack_public_path__ + "img/dori_Kalsiy_CS.585d89ff.jpeg";